import { render, staticRenderFns } from "./organizational-chart-header.component.vue?vue&type=template&id=46062b7a&scoped=true&"
import script from "./organizational-chart-header.component.vue?vue&type=script&lang=ts&"
export * from "./organizational-chart-header.component.vue?vue&type=script&lang=ts&"
import style0 from "./organizational-chart-header.component.vue?vue&type=style&index=0&id=46062b7a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46062b7a",
  null
  
)

export default component.exports